import {Injectable} from '@angular/core';
import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Store} from "@ngrx/store";
import * as wjcCore from "@grapecity/wijmo";

/**
 * /main/system 配下 (全支部横断画面) 用のガード。
 *
 * AdminGuard は role.category=='管理者' を見るが、それは支部管理者 (例: 群馬管理者) も満たすため
 * 全支部のデータを触らせてしまう。逆に全支部管理者の ORole は 管理者 / category='' / state='システム' で
 * category を持たないので AdminGuard を通れない。
 * そのため全支部画面は ContainerComponent.hasRoleName('管理者') と同じ判定 (role.name=='管理者') を使う。
 */
@Injectable()
export class SystemAdminGuard implements CanActivate {
    user: any;

    constructor(private router: Router, private store: Store<any>) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("lotasFeature").subscribe((lotas: any) => {
            this.user = lotas.user.user;
        });
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        if (wjcCore.isObject(this.user) && wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                if (role.name == "管理者") {
                    return true;
                }
            }
        }
        console.log("SystemAdminGuard Not System Admin")
        this.router.navigateByUrl('main/user');
        return false;
    }
}
